import { useCallback, useContext, useEffect } from 'react';
import type { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { IsDemoEnvContext, WebsocketConfigContext, SessionManagerContext } from '@trinity/chat-components/containers/Chat/contexts';
import { getSocket } from '../socket';

export const useGetSocket = (namespace: SocketNamespace): () => Socket => {

  const isDevEnv = useContext(IsDemoEnvContext);
  const socketOptions = useContext(WebsocketConfigContext);
  const sessionManager = useContext(SessionManagerContext);

  const sessionId = sessionManager?.sessionId;

  useEffect(() => {
    if (!sessionManager) return;

    // Get current session or create one if needed
    if (!sessionId) {
      sessionManager.refreshSession()
        .catch((error) => {
          console.error('Failed to initialize session for socket:', error);
        });
    }
  }, [sessionId, sessionManager]);

  return useCallback(() => {
    return getSocket({
      isDevEnv,
      namespace,
      baseUrl: socketOptions.baseUrl,
      socketPath: socketOptions.socketPath,
      sessionId,
    });
  }, [isDevEnv, namespace, socketOptions, sessionId]);
};